import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { initPress } from './lib/press.ts';
import './styles.css';

initPress();
createRoot(document.getElementById('root')!).render(<App />);

// offline app shell for the home-screen app; skipped by the dev server so rebuilds are never cached
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* the app still works online without it */ });
  });
}
